import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';
import { staffSteps } from '@/lib/siteData';

const StaffProcess = () => {
  return (
    <section id="proceso" className="bg-slate-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Talento confiable"
          title={
            <>
              NUESTROS PROCESOS DE SELECCIÓN,
              <br />
              CONTRATACIÓN Y CAPACITACIÓN
            </>
          }
          text="Nuestro proceso de reclutamiento y selección nos ha permitido garantizar nuestro trabajo durante 20 años en el mercado. Realizamos estudios psicológicos y sociolaborales para seleccionar a nuestro personal."
        />

        <div className="relative mt-16 grid gap-0 md:grid-cols-6 md:border-t md:border-[#0A2540]/20">
          {staffSteps.map((step, index) => (
            <motion.div
              key={step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="relative border-l border-[#0A2540]/20 py-5 pl-7 md:border-l-0 md:pl-0 md:pt-9"
            >
              {/* Número circular */}
              <span className="absolute -left-3 top-4 grid h-6 w-6 place-items-center text-[10px] font-bold text-white md:-top-3 md:left-0 bg-[#94cf1c]">
                {index + 1}
              </span>

              {/* Número grande de fondo */}
              <b className="block text-3xl font-light text-slate-300">
                0{index + 1}
              </b>

              {/* Título del paso */}
              <h3 className="mt-3 text-xs font-bold uppercase tracking-wide text-[#0A2540]">
                {step}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffProcess;